// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"94378e45","368":"94378e45","743":"c7a3c1ea","849":"b2b98e90","852":"44d8e9d4"}[chunkId] + ".chunk.css";
};